import React, { useState } from 'react'
import SydLabel from '../../../commonDesign/SydLabel'
import SydInput from '../../../commonDesign/SydInput'
import RoundedRectangleNode from '../Canvas/nodes/RoundedRectangleNode'
import { getRandomId } from './utils'

export const CustomNode = () => {
  const [header, setHeader] = useState('')
  const [description, setDescription] = useState('')

  const onDragStart = (event, account) => {
    event.dataTransfer.setData('application/reactflow', JSON.stringify({
      nodeType: 'roundedRectangle',
      id: `custom_${getRandomId()}`,
      data: {
        label: header,
        header: header,
        description: description,
        nodeProps: {
          size: 'sm'
        },
        entityProps: {
          type: 'custom'
        }
      }
    }))
    event.dataTransfer.effectAllowed = 'move'
  }

  return (
    <>
      <div>
        <SydLabel label='Name'>
          <SydInput
            size='sm'
            placeholder='Name'
            onChange={(e) => setHeader(e.target.value)}
            value={header}
            className='mb-2'
          />
        </SydLabel>
      </div>
      <div>
        <SydLabel label='Description' />
        <SydInput
          size='sm'
          placeholder='Description'
          onChange={(e) => setDescription(e.target.value)}
          value={description}
          className='mb-2'
        />
      </div>
      <div>
        <SydLabel label='Drag the placeholder below to add it to the canvas' />
        <div draggable onDragStart={onDragStart} className='relative'>
          <RoundedRectangleNode data={{ header, description }} width='100%' height='auto' />
        </div>
      </div>
    </>
  )
}
